window.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('.custom-info-tabs__accordion');
  const mediaWrappers = document.querySelectorAll('.custom-info-tabs__media-wrapper');

  accordions.forEach((accordion) => {
    const button = accordion.querySelector('.custom-info-tabs__accordion-button');

    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const currentTitle = button.getAttribute('data-title');

      if (isExpanded) return;

      // Reset all accordions
      accordions.forEach((otherAccordion) => {
        const otherButton = otherAccordion.querySelector('.custom-info-tabs__accordion-button');
        otherButton.setAttribute('aria-expanded', 'false');
      });

      // Reset all media wrappers
      mediaWrappers.forEach((wrapper) => {
        wrapper.classList.remove('active');
      });

      if (!isExpanded) {
        button.setAttribute('aria-expanded', 'true');

        // Find and activate corresponding media wrapper
        mediaWrappers.forEach((wrapper) => {
          if (wrapper.getAttribute('data-title') === currentTitle) {
            wrapper.classList.add('active');
          }
        });
      }
    });
  });
});
